module.exports = __webpack_public_path__ + "img/entrepreneurship-456.55672c73.png";